export const isMatch = (original, search) =>
  original.toLowerCase().indexOf(search.toLowerCase()) > -1;